import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';
import SessionRouter from './SessionRouter';

export {
  AppRouter,
  AuthRouter,
  SessionRouter,
};
export * from './RedirectToBackendSwitch';